<template>
  <el-dialog
    :title="isEdit ? '编辑群组' : '新增群组'"
    :visible="visible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="群名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入群名称" />
      </el-form-item>

      <el-form-item label="是否禁言" prop="isMuted">
        <el-radio-group v-model="form.isMuted">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="群公告">
        <el-input
          v-model="form.notice"
          type="textarea"
          :rows="3"
          placeholder="请输入群公告"
        />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="loading"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { createGroup, updateGroup } from "@/api/group";

export default {
  name: "GroupForm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    groupData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        name: "",
        groupType: 0,
        isPrivate: false,
        maxMemberCount: 500,
        status: 0,
        description: "",
        remark: "",
        // 确保与 el-radio 的数值标签一致
        isMuted: 1,
        // 与表单输入的公告字段保持响应式
        notice: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入群名称", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "长度在 2 到 20 个字符",
            trigger: "blur",
          },
        ],

        maxMemberCount: [
          { required: true, message: "请输入最大成员数", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.groupData;
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
      }
    },
  },
  methods: {
    initForm() {
      if (this.isEdit && this.groupData) {
        this.form = { ...this.groupData };
        // 将可能为字符串/布尔的值统一为数值 0/1，保证单选框正确选中
        this.form.isMuted =
          this.groupData.isMuted != null ? Number(this.groupData.isMuted) : 0;
        // 保证存在 notice 字段，避免未定义导致的非响应
        if (typeof this.form.notice === "undefined") {
          this.form.notice = "";
        }
      } else {
        this.form = {
          name: "",
          groupType: 0,
          isPrivate: false,
          maxMemberCount: 500,
          status: 0,
          description: "",
          remark: "",
          isMuted: 0,
          notice: "",
        };
      }

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate();
        this.loading = true;

        if (this.isEdit) {
          await updateGroup(this.groupData.id, this.form);
          this.$message.success("更新成功");
        } else {
          await createGroup(this.form);
          this.$message.success("创建成功");
        }

        this.$emit("success");
      } catch (error) {
        if (error !== false) {
          console.error("提交失败:", error);
          this.$message.error("操作失败");
        }
      } finally {
        this.loading = false;
      }
    },

    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
